// src/pages/BulkOrderUpload.js
import React, { useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  addDoc,
  serverTimestamp,
  deleteDoc,
  doc,
} from "firebase/firestore";

import BlankLayout from "../components/BlankLayout";

export default function BulkOrderUpload() {
  const [loading, setLoading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);

    const text = await file.text();
    const rows = text.split("\n").map(r => r.trim()).filter(Boolean);

    const headers = rows[0].split(",").map(h => h.trim());
    const skuHeaders = headers.slice(1); // after Party

    // 🔹 LOAD SKU MASTER
    const skuSnap = await getDocs(collection(db, "skuMaster"));
    const skuMap = {};
    skuSnap.forEach(d => {
      const data = d.data();
      skuMap[data.sku] = data;
    });

    // 🔹 LOAD PARTY MASTER
    const partySnap = await getDocs(collection(db, "partyMaster"));
    const partySet = new Set();
    const partyClientMap = {};
    partySnap.forEach(d => {
      const data = d.data();
      partySet.add(data.partyId);
      partyClientMap[data.partyId] = data.clientId;
    });

    // 🔴 VALIDATION
    for (let sku of skuHeaders) {
      if (!skuMap[sku]) {
        alert("SKU not found: " + sku);
        setLoading(false);
        return;
      }
    }

    // 🔴 DELETE OLD PENDING
    const oldSnap = await getDocs(
      query(collection(db, "orders"), where("status", "==", "PENDING"))
    );

    for (let d of oldSnap.docs) {
      await deleteDoc(doc(db, "orders", d.id));
    }

    // 🔵 CREATE NEW ORDERS
    for (let i = 1; i < rows.length; i++) {
      const cols = rows[i].split(",").map(c => c.trim());
      const partyId = cols[0];

      if (!partySet.has(partyId)) {
        alert("Party not found: " + partyId);
        setLoading(false);
        return;
      }

      const items = {};
      let totalQty = 0;
      let totalAmount = 0;

      for (let j = 1; j < cols.length; j++) {
        const sku = skuHeaders[j - 1];
        const qty = Number(cols[j] || 0);

        if (!qty) continue;

        const m = skuMap[sku];

        const basic = qty * Number(m.Basic_Eway || 0);
        const gst = basic * (Number(m.gst || 0) / 100);
        const cess = basic * (Number(m.cess || 0) / 100);
        const addl = qty * Number(m.addlcess || 0);
        const rebate = qty * Number(m.Rebate || 0);

        items[sku] = qty;
        totalQty += qty;
        totalAmount += basic + gst + cess + addl + rebate;
      }

      await addDoc(collection(db, "orders"), {
        clientId: partyClientMap[partyId],
        partyId,
        partyName: partyId,
        items,
        totalQty,
        totalAmount,
        status: "PENDING",
        source: "BULK_UPLOAD",
        createdAt: serverTimestamp(),
      });
    }

    alert("Bulk orders uploaded successfully");
    setLoading(false);
  };

  return (
    <BlankLayout>
      <div style={{ padding: 30 }}>
        <h2>Bulk Order Upload</h2>

        <input type="file" accept=".csv" onChange={handleFile} />

        {loading && <p>Uploading… please wait</p>}
      </div>
    </BlankLayout>
  );
}
